var gtm = require('googletagmanager/tagManager');
var base = require('base/components/footer');
// eslint-disable-next-line require-jsdoc
function getContentModalHtmlElement() {
    if ($('#contentMagnetModal').length !== 0) {
        $('#contentMagnetModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade content-magnet-modal" id="contentMagnetModal" role="dialog" tabindex="-1">'
        + '<div class="modal-dialog content-dialog ibc-magnet">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right colse-button-ibc-magnet" data-dismiss="modal">'
        + '        <span aria-hidden="true" class="close-img"></span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body">'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

// eslint-disable-next-line require-jsdoc
function getInactivePrimaryModal() {
    if ($('#inactive-primary-modal').length !== 0) {
        $('#inactive-primary-modal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade content-magnet-modal inactive-primary-modal" id="inactive-primary-modal" role="dialog" tabindex="-1">'
        + '<div class="modal-dialog modal-dialog-centered content-dialog ibc-magnet">'
        + '<!-- Modal content-->'
        + '<div class="modal-content mk-card-size">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true" class="close-img"></span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body">'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Trap keyboard focus within a Bootstrap modal instance.
 * @param {JQuery} $modal - jQuery modal element to wire focus handling for
 */
function setupModalFocusTrap($modal) {
    var focusableSelector = 'a[href], area[href], [href]:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex^="-"]), [contenteditable="true"]';
    $modal.off('.focusTrap');
    $modal.on('shown.bs.modal.focusTrap', function () {
        var $focusableItems = $modal.find(focusableSelector).filter(':visible');
        if ($focusableItems.length) {
            $focusableItems.first().trigger('focus');
        } else {
            $modal.attr('tabindex', '-1').trigger('focus');
        }
    });
    $modal.on('keydown.focusTrap', function (event) {
        if (event.key !== 'Tab') {
            return;
        }
        var $focusableItems = $modal.find(focusableSelector).filter(':visible');
        if (!$focusableItems.length) {
            return;
        }
        var currentIndex = $focusableItems.index($(document.activeElement));
        if (currentIndex === -1) {
            // If focus lands outside, redirect to start/end based on tab direction
            event.preventDefault();
            if (event.shiftKey) {
                $focusableItems.last().trigger('focus');
            } else {
                $focusableItems.first().trigger('focus');
            }
            return;
        }
        if (event.shiftKey) {
            if (currentIndex <= 0) {
                event.preventDefault();
                $focusableItems.last().trigger('focus');
            }
            return;
        }
        if (currentIndex === $focusableItems.length - 1) {
            event.preventDefault();
            $focusableItems.first().trigger('focus');
        }
    });
    $modal.on('hidden.bs.modal.focusTrap', function () {
        $modal.off('.focusTrap');
        var $returnTarget = $('#myaccount');
        if (!$returnTarget.length) {
            $returnTarget = $('[aria-label="Account Settings"]');
        }
        if ($returnTarget.length) {
            $returnTarget.trigger('focus');
        }
    });
}

$(function () {
    var modalBody = $('.ibc-magnet-modal-content').find('.ibc-magnet-modal-js.ibc-magnet-modal');
    if(modalBody.length) {
        getContentModalHtmlElement();
        var $magnetModal = $('#contentMagnetModal');
        $magnetModal.find('.modal-body').empty().html(modalBody);
        setupModalFocusTrap($magnetModal);
        $magnetModal.modal('show');
    }
    var inactivePrimaryModalBody = $('.inactive-primary-modal-content').find('.inactive-primary-modal');
    if(inactivePrimaryModalBody.length) {
        getInactivePrimaryModal();
        var $inactivePrimaryModal = $('#inactive-primary-modal');
        $inactivePrimaryModal.find('.modal-body').empty().html(inactivePrimaryModalBody);
        setupModalFocusTrap($inactivePrimaryModal);
        $inactivePrimaryModal.modal('show');
    }
    var newConnectionmodalBody = $('.new-connection-content-js').find('.new-connection-modal-js');
    if(newConnectionmodalBody.length) {
        $('.new-connection-btn').trigger('click');
    }
    var primaryIBCTerminatedBody = $('.ibc-terminated-content-js').find('.ibc-terminate-modal-js');
    if(primaryIBCTerminatedBody.length) {
        $('.ibc-terminated-btn').trigger('click');
    }
});

/**
 * Delete a cookie by setting its expiration date to the past
 * @param {string} cookieName - name of the cookie
 */
function deleteCookie(cookieName) {
    let cookieString = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
    document.cookie = cookieString;
}

$('body').on('click', '.find-consultant-ibc-magnet, .colse-button-ibc-magnet', function() {
    deleteCookie('shop');
});
$(document).on('click', '.view-profile-btn.tray-footer a', function () {
    gtm.viewProfileSelectHeader($(this).data('consultantnumber'), $(this).data('active'));
});
$(document).on('click', '.contact-link', function () {
    gtm.contactIbc($(this).data('store-id'), $(this).data('type'), $(this).data('active'))
});
$(document).on('click', '.js-gtm-promo-banner, .js-gtm-carousel-slide, .js-gtm-promo-itc', function () {
    var $el = $(this);
    var promoId = $el.data('gtm-promo-id') || '';
    var promoName = $el.data('gtm-promo-name') || '';
    var creativeName = $el.data('gtm-creative-name') || '';
    var creativeSlot = $el.data('gtm-creative-slot') || '';
    if (promoId.length > 0 || promoName.length > 0)
        gtm.selectPromotion(creativeName, creativeSlot, promoId, promoName)
});

$(window).on('load', function () {
    var $gtmTrackPromos = $('.js-gtm-promo-banner, .js-gtm-promo-itc');
    if (!$gtmTrackPromos.length) {
        return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var $el = $(entry.target);

                // Prevent duplicate firing
                if ($el.data('gtm-fired')) {
                    return;
                }

                var promoId = $el.data('gtm-promo-id') || '';
                var promoName = $el.data('gtm-promo-name') || '';
                var creativeName = $el.data('gtm-creative-name') || '';
                var creativeSlot = $el.data('gtm-creative-slot') || '';

                if (promoId && promoName) {
                    gtm.viewPromotion(
                        creativeName,
                        creativeSlot,
                        promoId,
                        promoName
                    );

                    // Mark as fired
                    $el.data('gtm-fired', true);

                    // Stop observing this element
                    obs.unobserve(entry.target);
                }
            }
        });
    }, {
        threshold: 0.5 // 50% visible
    });

    $gtmTrackPromos.each(function () {
        observer.observe(this);
    });
});

$(document).on('click', '.shop-with-me-gtm', function () {
    gtm.consultantLocatorSelect($(this).data('search-method'), $(this).data('store-id'), $(this).data('location'), $(this).data('slot'), $(this).data('active'))
});


module.exports = base;
